'use strict';

module.exports = function (ngModule) {
  ngModule.filter('additionName', function() {
    return function(input) {
      var display = '';
      input = parseInt(input, 10);

      if (input === 0) {
        display = 'standard';
      } else if (input === 1) {
        display = 'full';
      } else {
        display = input;
      }

      return display;
    };
  });
};



//////////////////
// WEBPACK FOOTER
// ./js/filters/display.js
// module id = 55
// module chunks = 0